module.exports = __webpack_public_path__ + "static/media/tortle02.141c965c.png";